import React from 'react'
import { fetchVisionEnabled } from '../services/visionService'

export function useVisionEnabled() {
  const [enabled, setEnabled] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    let mounted = true
    ;(async () => {
      try {
        const ok = await fetchVisionEnabled()
        if (!mounted) return
        setEnabled(ok)
      } catch {
        if (!mounted) return
        setEnabled(false)
      }
    })()
    return () => {
      mounted = false
    }
  }, [])

  return enabled
}
